import { render } from "./offerInfo2.vue?vue&type=template&id=744502be&scoped=true"
import script from "./offerInfo2.vue?vue&type=script&lang=js"
export * from "./offerInfo2.vue?vue&type=script&lang=js"

import "./offerInfo2.vue?vue&type=style&index=0&id=744502be&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744502be"]])

export default __exports__